export default [
    {
        type: "selection",
        width: 38,
        align: "center",
    },

    {
        title: 'Role Name',
        key: 'Name',
        minWidth: 80,
    }
]
